webpackJsonp([129],{

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(952);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("26b26a7b", content, true, {});

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".GridRichTextEditor1 .grid{margin-left:0;border-top:1px solid #e6e6e6;padding-top:4rem}.GridRichTextEditor1 .grid .grid-item{margin-bottom:4rem;border-bottom:1px solid #e6e6e6;padding-bottom:4rem}@media (min-width:768px){.GridRichTextEditor1 .grid .grid-item:nth-child(odd)>div{border-right:1px solid #e6e6e6;padding-right:2.5rem}.GridRichTextEditor1 .grid .grid-item:nth-child(2n)>div{padding-left:2.5rem}}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/GridRichTextEditor1/src/components/contents/GridRichTextEditor1/GridRichTextEditor1.s.scss"],"names":[],"mappings":"AAEA,2BAKI,cAAc,AACd,6BAJ0B,AAK1B,gBAHe,CAkBhB,AAtBH,sCASM,mBALa,AAMb,gCARwB,AASxB,mBAPa,CAQd,AACD,yBAbJ,yDAeQ,+BAbsB,AActB,oBAba,CAcd,AAjBP,wDAmBQ,mBAhBa,CAiBd,CAAA","file":"GridRichTextEditor1.s.scss","sourcesContent":["@import '~scss/variables';\n\n.GridRichTextEditor1 {\n  .grid {\n    $border: 1px solid #e6e6e6;\n    $gutter_x: 2.5rem;\n    $gutter_y: 4rem;\n    margin-left: 0;\n    border-top: $border;\n    padding-top: $gutter_y;\n    .grid-item {\n      margin-bottom: $gutter_y;\n      border-bottom: $border;\n      padding-bottom: $gutter_y;\n    }\n    @media (min-width: breakpoint('m')) {\n      .grid-item:nth-child(odd) > div {\n        border-right: $border;\n        padding-right: $gutter_x;\n      }\n      .grid-item:nth-child(even) > div {\n        padding-left: $gutter_x;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/129.712ab14c20d5808b8780.js